import MarkdownViewer from "../components/MarkdownViewer";

const MarkdownPage = () => {
    return (
        <div className="markdown-container">
           <MarkdownViewer />
        </div>
    );
};

export default MarkdownPage;